module.exports = __webpack_public_path__ + "static/media/csrd_report_bg1.d69b7c88.svg";